// src/analytics.js
// Google Analytics (GA4) — loaded ONLY from the public marketing/legal pages
// (LandingPage, PrivacyPolicy, TermsOfService in src/pages/pages.jsx). Never
// imported or called from App.jsx (the authenticated app) — that's a
// deliberate boundary: the app itself tracks no usage/habit data (see the
// Privacy Policy), but the marketing site gets ordinary visitor analytics
// like any other website.
//
// No-ops entirely until REACT_APP_GA_MEASUREMENT_ID is set (see .env / Azure
// SWA app settings) — safe to ship with no ID configured yet.

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let scriptLoaded = false;

function loadGtagScript() {
  if (scriptLoaded || !GA_ID) return;
  scriptLoaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  // send_page_view: false — we fire page_view explicitly per marketing page
  // mount instead, so SPA navigation between landing/privacy/terms is tracked
  // correctly (the default auto page_view only fires once, on script load).
  window.gtag('config', GA_ID, { send_page_view: false });
}

const isNative = typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.();

// Call from a marketing/legal page's mount effect. Loads the script on first
// call, a no-op on every call after that beyond firing the page_view.
// Skips entirely inside the native iOS/Android app shell — this is scoped to
// the habitrak.io *website* specifically, not the native app.
export function trackMarketingPageview(path) {
  if (!GA_ID || isNative) return;
  loadGtagScript();
  window.gtag?.('event', 'page_view', { page_path: path || window.location.pathname });
}
